import React, { useEffect, useState } from 'react'
import styles from './styles.module.scss'
import { connect } from 'react-redux'
import { getCurrentTest, getTestQuestions, clearTestToken } from '../../actions/testing'
import Loader from 'react-loader';
import Modal from './Modal';


const mapStateToProps = ({ testing }) => {
  const { current: data, loading, can_try } = testing
  const { list: questions } = testing.questions
  return { data, questions, loading, can_try }
}

const CurrentTest = ({
  getCurrentTest,
  getTestQuestions,
  clearTestToken,
  data,
  questions,
  loading,
  match,
  location,
  can_try,
  history
}) => {

  const testId = parseInt(match.params.testId)

  const [testStatus, setTestStatus] = useState('')
  const [question, setQuestion] = useState(null)
  const [timeOver, setTimeOver] = useState(false)
  const [questionsList, setQuestionsList] = useState([])

  useEffect(() => {
    setNewAttempt()
  }, [questions])

  useEffect(() => {
    if (!testId) return;
    getTestQuestions(testId)
    getCurrentTest(testId)
  }, [])


  useEffect(() => {
    if (testStatus !== 'started') return;
    const testNotPAssed = questionsList.find(({ passed }) => !passed)
    !testNotPAssed && finishTest()
  }, [questionsList])

  const setNewAttempt = () => {
    if (!questions) return;
    const questionsList = questions.map(question => ({ ...question, passed: false }))
    setQuestionsList(questionsList)
  }

  const setQuestionPassed = (index) => () => {
    const newQuestionsList = JSON.parse(JSON.stringify(questionsList))
    newQuestionsList[index].passed = true
    setQuestionsList(newQuestionsList)
  }

  console.log(questionsList)

  const startTestHandler = () => {
    setTestStatus('started')
    setQuestion(0)
  }

  const setCurrentQuestion = (number) => () => {
    setQuestion(number)
  }

  const closeTestHandler = () => {
    clearTestToken()
    const { state } = location
    if (state) return history.push({ pathname: '/current_performance', state })

    setTestStatus('')
    setQuestion(null)
    setTimeOver(false)
    setNewAttempt()
  }

  const prevButtonDisabled = testStatus === 'finished' || question - 1 < 0
  const nextButtonDisabled = testStatus === 'finished' || question + 1 >= questionsList.length

  const nextQuestion = () => {
    if (nextButtonDisabled) return;
    setQuestion(question + 1)
  }

  const prevQuestion = () => {
    setTestStatus('started')
    if (prevButtonDisabled) return;
    setQuestion(question - 1)
  }

  const finishTest = () => {
    setTestStatus('finished')
    setTimeOver(true)
    setQuestion(null)
    setNewAttempt()
  }

  const repeatHandler = () => {
    setTestStatus('started')
    setQuestion(0)
    setNewAttempt()
    setTimeOver(false)
  }

  if (loading) return <Loader />;

  if (!testId || !data) return null;

  const attempts = data.trying - data.user_trying

  return (
    <div className={styles.wrapper}>

      <p>{data.name}</p>
      <p>{data.description}</p>

      <div className={styles.charactBlock}>
        <span>Продолжительность: </span>
        <span>{data.total_worktime} мин</span>
      </div>

      <div className={styles.charactBlock}>
        <span>Количество вопросов:</span>
        <span>{questionsList.length}</span>
      </div>

      <div className={styles.charactBlock}>
        <span>Количество оставшихся попыток:</span>
        <span>{attempts <= 0 ? `0 (тест пройден)` : attempts}</span>
      </div>

      <div className={styles.buttonBlock}>
        <button
          disabled={!can_try}
          onClick={startTestHandler}
          title={data.availability_answers ? 'Тест уже пройден' : ''}
        >
          Начать тест
        </button>
      </div>

      <Modal
        isOpen={!!testStatus}
        data={data}
        closeTestHandler={closeTestHandler}
        nextQuestion={nextQuestion}
        prevQuestion={prevQuestion}
        nextButtonDisabled={nextButtonDisabled}
        prevButtonDisabled={prevButtonDisabled}
        questionInd={question}
        setCurrentQuestion={setCurrentQuestion}
        testFinished={testStatus === 'finished'}
        testId={testId}
        timeOver={timeOver}
        setTimeOver={setTimeOver}
        finishTest={finishTest}
        questions={questionsList}
        question={question}
        setQuestionPassed={setQuestionPassed}
        can_try={can_try}
        repeatHandler={repeatHandler}
      />

    </div>
  )
}

export default connect(mapStateToProps, { getCurrentTest, getTestQuestions, clearTestToken })(CurrentTest)